import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { MemberChangePassword } from "../RamNamBookCRUD";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import MemberHeader from "./MemberHeader";
import { Badge } from "react-bootstrap";
import { Link } from "react-scroll";

const changePasswordInitValue = {
  oldPassWord: "",
  newPassWord: "",
  conformNewPassWord: "",
};

const profileDetailsSchema = Yup.object().shape({
  oldPassWord: Yup.string().required("Old Password is required"),
  newPassWord: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("New Password is required"),
  conformNewPassWord: Yup.string()
    .oneOf([Yup.ref("newPassWord")], "Passwords must match")
    .required("Confirm Password is required"),
});

const ResetPassword = () => {
  const navigate = useNavigate();
  const [memberId, setMemberId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);

  useEffect(() => {
    const storedCustomer = localStorage.getItem("customer");
    if (!storedCustomer) return;

    const customerObj = JSON.parse(storedCustomer);
    setMemberId(customerObj?.ramNamBookMemberID || null);
  }, []);

  const formik = useFormik({
    initialValues: changePasswordInitValue,
    validationSchema: profileDetailsSchema,
    onSubmit: async (values) => {
      if (!memberId) {
        toast.error("Member ID not found");
        return;
      }

      try {
        setLoading(true);
        const resp = await MemberChangePassword(
          memberId,
          values.oldPassWord,
          values.newPassWord,
        );

        if (resp?.data?.isSuccess) {
          toast.success("Password Change Successfully");
          navigate("/member/dashboard");
        } else {
          toast.error(resp?.data?.message);
        }
      } catch (error) {
        toast.error("Something went wrong");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <MemberHeader MemberHeader />
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8">
            <div className="card shadow-lg border-0 rounded-4">
              <div className="card-header bg-white border-0 text-center pt-4">
                <h6 className="fw-bold mb-1 text-[#FF4F00]">Reset Password</h6>
                {/* <p className="text-muted mb-0">
                  Please enter your new password below
                </p> */}
              </div>

              <div className="card-body px-4 py-4">
                <form onSubmit={formik.handleSubmit}>
                  {/* New Password */}
                  <div className="mb-4">
                    <label className="form-label fw-semibold">
                      Old Password
                    </label>
                    <div className="input-group">
                      <input
                        type={showOldPassword ? "text" : "password"}
                        className="form-control form-control-md"
                        placeholder="Enter new password"
                        {...formik.getFieldProps("oldPassWord")}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setShowOldPassword(!showOldPassword)}
                      >
                        {showOldPassword ? (
                          <EyeInvisibleOutlined />
                        ) : (
                          <EyeOutlined />
                        )}
                      </button>
                    </div>
                    {formik.touched.oldPassWord &&
                      formik.errors.oldPassWord && (
                        <div className="text-danger small mt-1">
                          {formik.errors.oldPassWord}
                        </div>
                      )}
                  </div>
                  <div className="mb-4">
                    <label className="form-label fw-semibold">
                      New Password
                    </label>
                    <div className="input-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control form-control-md"
                        placeholder="Enter new password"
                        {...formik.getFieldProps("newPassWord")}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <EyeInvisibleOutlined />
                        ) : (
                          <EyeOutlined />
                        )}
                      </button>
                    </div>
                    {formik.touched.newPassWord &&
                      formik.errors.newPassWord && (
                        <div className="text-danger small mt-1">
                          {formik.errors.newPassWord}
                        </div>
                      )}
                  </div>
                  {/* Confirm Password */}
                  <div className="mb-4">
                    <label className="form-label fw-semibold">
                      Confirm Password
                    </label>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control form-control-md"
                      placeholder="Confirm new password"
                      {...formik.getFieldProps("conformNewPassWord")}
                    />
                    {formik.touched.conformNewPassWord &&
                      formik.errors.conformNewPassWord && (
                        <div className="text-danger small mt-1">
                          {formik.errors.conformNewPassWord}
                        </div>
                      )}
                  </div>

                  {/* Save Button */}
                  <div className="d-grid mt-4">
                    <button
                      type="submit"
                      style={{ backgroundColor: "#FF4F00", color: "#fff" }}
                      className="btn btn-primary btn-lg rounded-3"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          Please wait...
                          <span className="spinner-border spinner-border-sm ms-2"></span>
                        </>
                      ) : (
                        "Save Changes"
                      )}
                    </button>
                  </div>
                </form>
              </div>

              <div className="card-footer badge bg-white border-0 text-center pb-4">
                <Badge className="cursor-pointer">
                  <Link
                    className="mb-2"
                    onClick={() => navigate("/member/dashboard")}
                  >
                    ← Back to Dashboard
                  </Link>
                </Badge>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
